export const cancellationPolicyReducerSelector = state => state.cancellationPolicyReducer;